module.exports = __webpack_public_path__ + "img/follow-up.f44fe18e.svg";